import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral } from '../../../../style/colors';
import CopyButton from '../../../../components/CopyButton/CopyButton';

export const Section = styled.div`
  padding: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 24px;
  letter-spacing: -0.3px;
`;

export const SpecsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 20px;
`;

export const SpecCard = styled.div`
  background: ${neutral[50]};
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid ${neutral[200]};
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${rgba(primary[500], 0.15)};
    border-color: ${primary[500]};

    .copy-button {
      opacity: 1;
    }
  }
`;

export const SpecHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`;

export const SpecIcon = styled.i`
  font-size: 16px;
  color: ${primary[500]};
`;

export const SpecLabel = styled.div`
  font-size: 12px;
  color: ${primary[500]};
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  flex: 1;
`;

export const SpecValue = styled.div`
  font-size: 16px;
  color: ${neutral[900]};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const StyledCopyButton = styled(CopyButton)`
  opacity: 0;
  transition: opacity 0.2s ease;

  @media (max-width: 768px) {
    opacity: 1;
  }
`;
